import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MergeLanguagesForm } from '@app/models/form.models';
import { ButtonComponent } from '@app/ui-components/button/button.component';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-localization-tab',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe,
    ValidatedInputComponent,
    ButtonComponent,
  ],
  templateUrl: './localization-tab.component.html',
  styleUrl: './localization-tab.component.scss',
})
export class LocalizationTabComponent {
  public showButtons = input<boolean>(true);
  public disableSave = input.required<boolean>();

  public formGroupInput = input.required<
    FormGroup<{
      [language: string]: FormGroup<MergeLanguagesForm>;
    }>
  >();

  protected controls = computed(() =>
    Object.entries(this.formGroupInput().controls).map(([key, group]) => ({
      key,
      group,
    }))
  );

  trackByIndex = (index: number) => index;

  public emitCancel = output<void>();
  public emitSave = output<void>();

  save() {
    this.emitSave.emit();
  }
  cancel() {
    this.emitCancel.emit();
  }
}
